import { useCallback } from "react";
import { useNotification } from "../classes/contexts/NotificationContext";

export const useSnackbar = () => {
  const { addNotification, removeNotification } = useNotification();

  const showSnackbar = useCallback(
    (type, message, options = {}) => {
      return addNotification(type, message, options);
    },
    [addNotification]
  );

  const hideSnackbar = useCallback(
    (id) => {
      if (id) {
        removeNotification(id);
      }
    },
    [removeNotification]
  );

  return {
    showSnackbar,
    hideSnackbar,
  };
};